import React from 'react'
import './brandAssets.css'

// import NavPage from "../navPage/NavPage";
import BrandHeader from '../brandAssets/BrandHeader';
import BrandBody from '../brandAssets/BrandBody';
import Footer2 from "../footer2/Footer2";

function BrandAssets() {
  return (
    <section>
          {/* <NavPage/>  */}
            <div id='brand-assetsNavApp'>
                <BrandHeader/>
            </div>
              <BrandBody/> 
          <Footer2/>
    </section>
  )
}

export default BrandAssets
